<template>
  <!--card-->
  <div class="card" :style="{ minHeight: height + 'px', width: width + '%'}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      default: 100
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 5px;
    background: #fff;
    padding: 10px 12px;
  }
</style>
